import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../cn";
const variantClasses = {
    "hero-title": "font-title text-2xl text-primary",
    "page-title": "font-title text-xl text-primary max-sm:text-lg",
    "section-title": "font-title font-medium text-base text-primary",
    "card-title": "font-title font-medium text-base text-primary leading-tight",
    "field-label": "font-title font-medium text-sm text-secondary",
    "detail-label": "font-title text-secondary text-xs",
    "column-label": "font-title font-medium text-secondary text-xs",
    body: "text-primary text-sm",
    value: "font-medium text-base text-primary",
    metric: "text-lg text-primary",
    "page-description": "text-base text-secondary max-sm:text-sm",
    description: "text-secondary text-sm",
    caption: "text-tertiary text-xs",
    name: "font-title font-medium text-primary text-sm",
    mono: "font-mono text-secondary text-sm",
};
const toneClasses = {
    default: "",
    primary: "!text-primary",
    secondary: "!text-secondary",
    tertiary: "!text-tertiary",
    success: "!text-success",
    warning: "!text-warning",
    danger: "!text-danger",
    info: "!text-info",
    accent: "!text-accent",
    inherit: "!text-inherit",
};
const inverseToneClasses = {
    default: "!text-primary-inverse",
    primary: "!text-primary-inverse",
    secondary: "!text-secondary-inverse",
    tertiary: "!text-tertiary-inverse",
    success: "!text-success-inverse",
    warning: "!text-warning-inverse",
    danger: "!text-danger-inverse",
    info: "!text-info-inverse",
    accent: "!text-accent",
    inherit: "!text-inherit",
};
const elementByVariant = {
    "hero-title": "p",
    "page-title": "h1",
    "section-title": "h2",
    "card-title": "h3",
    "field-label": "label",
    "detail-label": "span",
    "column-label": "span",
    body: "p",
    value: "span",
    metric: "span",
    "page-description": "p",
    description: "p",
    caption: "span",
    name: "span",
    mono: "code",
};
/** Unified typography — pick a `variant`, everything else follows. */
export const Txt = forwardRef(function Txt(props, ref) {
    const { variant = "body", tone = "default", inverseTone = false, truncate, nowrap, children, id, htmlFor, } = props;
    const Element = elementByVariant[variant];
    return (_jsx(Element, { ref: ref, id: id, htmlFor: htmlFor, className: cn(variantClasses[variant], (inverseTone ? inverseToneClasses : toneClasses)[tone], truncate && "min-w-0 truncate", nowrap && "whitespace-nowrap"), children: children }));
});
